var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ad-url-icon',{attrs:{"ad":_vm.ad}}),_vm._v(" "),_c('ad-content-icon',{attrs:{"ad":_vm.ad}}),_vm._v(" "),_c('ad-dtp-comment-icon',{attrs:{"ad":_vm.ad}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }